import React, { PureComponent, Fragment } from 'react';
import compose from 'ramda/es/compose';
import filter from 'ramda/es/filter';
import map from 'ramda/es/map';
import addIndex from 'ramda/es/addIndex';
import identity from 'ramda/es/identity';
import { List as ImmutableList } from 'immutable';
import PropTypes from 'prop-types';
import { MenuItem } from './menuItem';
import { Search } from './search';
import { List } from '../../../theme/layout';
import { HamburgerMenu } from './hamburgerMenu/index';
import { renderWhenTrue } from '../../../utils/rendering';
import { getField, getFieldIn } from '../../../utils/cmsData';
import { LanguageDropdown } from '../../../components/languageDropdown';

const mapIndexed = addIndex(map);

const getLast = array => {
  return [array[array.length - 1]];
};

const getItemFields = item => {
  const list = getField('items', item);
  const link = list ? list.toArray().shift() : item;

  const featured = getField('featured', link);
  const title = getField('title', link) || getField('name', item);
  const url = getFieldIn(['url', 'url'], link);
  const useSecondaryColor = getField('useSecondaryColor', link);

  return {
    featured,
    list,
    title,
    url,
    useSecondaryColor,
  };
};

export class Menu extends PureComponent {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    menu: PropTypes.object,
    showsBurgerMenu: PropTypes.bool,
    isSmallDevice: PropTypes.bool,
    isOpened: PropTypes.bool,
    setMenuOpened: PropTypes.func,
    form: PropTypes.object,
  };

  onHamburgerClick = () => {
    this.props.setMenuOpened(!this.props.isOpened);
  };

  get menu() {
    return this.props.menu || new ImmutableList();
  }

  renderMenu = () => {
    const { showsBurgerMenu, isSmallDevice } = this.props;

    return (
      <List row>
        {compose(
          mapIndexed((item, index) => this.renderMenuItem(item, index)),
          isSmallDevice ? getLast : identity,
          showsBurgerMenu ? filter(item => getItemFields(item).featured) : identity,
        )(this.menu.toArray())}
        <Search />
      </List>
    );
  };

  renderHamburger = () => {
    return <HamburgerMenu onClick={this.onHamburgerClick} isMenuOpened={this.props.isOpened} />;
  };

  renderMenuItem = (item, index) => {
    const { featured, list, title, url, useSecondaryColor } = getItemFields(item);
    const { showsBurgerMenu } = this.props;
    return (
      <MenuItem
        key={index}
        list={showsBurgerMenu ? null : list}
        url={url}
        title={title}
        isFeatured={featured}
        useSecondaryColor={useSecondaryColor}
      />
    );
  };

  renderLanguageSelector = () => <LanguageDropdown />;

  render() {
    const { showsBurgerMenu, isOpened } = this.props;

    if (!this.menu.size) {
      return null;
    }

    return (
      <Fragment>
        {renderWhenTrue(this.renderMenu)((!isOpened && showsBurgerMenu) || !showsBurgerMenu)}
        {renderWhenTrue(this.renderHamburger)(showsBurgerMenu)}
        {renderWhenTrue(this.renderLanguageSelector)(!showsBurgerMenu)}
      </Fragment>
    );
  }
}
